import React from "react";
import { useTranslation } from "react-i18next";
import { AssetType } from "static/types";

type PropsType = {
  assetType: any;
  inputValue: any;
  setInputValue: any;
  setIsActive: any;
  fromLots?: number;
  decimalPlaces?: number;
  placeholder?: string;
};
const QuantityInput: React.FC<PropsType> = ({
  assetType,
  inputValue,
  setInputValue,
  setIsActive,
  fromLots = 1,
  decimalPlaces,
  placeholder,
}) => {
  const { t } = useTranslation("app");
  const handleInputChange = (e: any) => {
    const strValue = String(e.target.value);
    const value =
      assetType === String(AssetType.Currency) || decimalPlaces
        ? decimalPlaces
          ? +(+strValue).toFixed(decimalPlaces) || ""
          : +strValue || ""
        : parseInt(e.target.value);
    setInputValue(value as number);
  };

  // ? chaneg to this maybe
  // const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   const value = Number(e.target.value);
  //   setInputValue(Number(value.toFixed(4)));
  // };

  const handleFocus = () => {
    setIsActive(true);
    if (inputValue == 0) {
      setInputValue("");
    }
  };

  return (
    <input
      id="quantity"
      type="number"
      placeholder={placeholder ? placeholder : t("from1Lot")}
      autoComplete="off"
      onFocus={() => handleFocus()}
      onBlur={() => setIsActive(false)}
      onChange={handleInputChange}
      value={inputValue}
      min={0}
      step={1}
    />
  );
};

export default QuantityInput;
